import { IBlogCategory } from '../interfaces/IBlogCategory';

const BLOG_CATEGORIES: IBlogCategory[] = [
  { value: 'All', key: 'all', color: 'brandOrange' },
  { value: 'Search', key: 'search', color: 'brandOrange' },
  { value: 'Case Studies', key: 'case-studies', color: 'brandNavy' },
  {
    value: 'Exterior Contractors',
    key: 'exterior-contractors',
    color: 'brandOrange',
  },
  { value: 'Homeowners', key: 'homeowners', color: 'brandGreen' },
  { value: 'Insurance', key: 'insurance', color: 'brandBrown' },
  { value: 'News', key: 'news', color: 'brandYellow' },
  { value: 'Product Updates', key: 'product-updates', color: 'brandRed' },
];

export default BLOG_CATEGORIES;
